// UWAGA: Wykorzystane w OPAC
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form" // optional
  ]

  connect() {
    setTimeout(() => this.setFocusFromLocation());
  }

  setFocusFromLocation() {
    const focus = (new URLSearchParams(location.search)).get("focus")
    if (focus) {
      const el = document.getElementById(focus)
      el.dispatchEvent(new Event(`${this.identifier}:focus`));
      el.focus()
    }
  }

  get form() { return this.hasFormTarget ? this.formTarget : this.element }

  submit(event) {
    const form = event.target.form || this.form
    if (event.currentTarget.id) form.appendChild(this.createFocusInput(event.currentTarget.id))
    form.requestSubmit()
  }

  // check if closest have [data-block-submit="true"]
  safeSubmit(event) {
    if (!event.currentTarget.closest(`[data-block-submit="true"]`)) {
      this.submit(event)
    }
  }

  createFocusInput(value) {
    const focusInput = document.createElement("input")
    focusInput.type = "hidden"
    focusInput.name = "focus"
    focusInput.value = value
    return focusInput
  }
}
